/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Chair/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChairFilled from 'DesignSystem/Svgs/Tysiav2ChairFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Chair({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Chair"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentBookingSeatedChairCodeValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'seated_chair_code',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Chair.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-4GFqI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2ChairFilled
  viewPath={`${viewPath}/Tysiav2ChairFilled`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={18}
 weight="bold"
 color={dtColorsNeutral900}
 overflowX="hidden"
 overflowY="hidden"
 textOverflow="ellipsis"
 display="block"
 whiteSpace="nowrap"
 data="appointment_booking.seated_chair_code"
 text={appointmentBookingSeatedChairCodeValueData}
 title={appointmentBookingSeatedChairCodeValueData}
/>
</div>
{children}
</React.Fragment>)
}